import { IChoice, IClinic } from '@/store/modules/form'

export interface ReservationFormViewModel {
  // クリニック
  clinic: IClinic
  // 診察種類
  treatmentCategoryName: string
  // ご希望の治療
  desiredTreatment: string
  // 予約内容
  isFirstTreatment: string
  // ご予約日
  reservationDate: Date
  // 第1候補日
  firstChoice: IChoice
  // 第2候補日
  secondChoice: IChoice
  // おなまえ
  firstName: string
  lastName: string
  // 生年月日
  birthYear: number
  birthMonth: number
  birthDate: number
  // 電話番号
  phoneNumber: string
  // メールアドレス
  email: string
  // 連絡方法
  contactTool: string
  // ご意見・ご質問
  comment: string
  // spotId
  treatmentSpotId: string
}

export const initReservationFormViewModel = (): ReservationFormViewModel => {
  return {
    // クリニック
    clinic: {
      medicalBusinessId: '',
      name: '',
      clinicId: '',
      clinicalDepartmentId: '',
      treatmentCourseId: '',
      business_hours: [],
      holiday_flag: false,
      businessDays: [],
      nonTargetDays: []
    },
    // 診察種類
    treatmentCategoryName: '',
    // 診察種類
    desiredTreatment: '',
    // 予約内容
    isFirstTreatment: '',
    // ご予約日
    reservationDate: new Date(),
    // 第1候補日
    firstChoice: {
      reservationDate: null,
      isAm: null
    },
    // 第2候補日
    secondChoice: {
        reservationDate: null,
        isAm: null
    },
    // おなまえ
    firstName: '',
    lastName: '',
    // 生年月日
    birthYear: 1980,
    birthMonth: 1,
    birthDate: 1,
    // 電話番号
    phoneNumber: '',
    // メールアドレス
    email: '',
    // 連絡方法
    contactTool: '',
    // ご意見・ご質問
    comment: '',
    // spotId
    treatmentSpotId: ''
  }
}
